import React from 'react';
import Header from '../components/Header';
import SecondYearMarksheetVerification from '../components/SecondYearMarksheetVerification';
import Footer from '../components/Footer';

const SecondYearMarksheetPage = () => {
    return (
        <div>
            <Header />
            <SecondYearMarksheetVerification />
            <Footer />
        </div>
    );
};

export default SecondYearMarksheetPage;
